import type { BeforeErrorHook } from "ky";
import { isHTTPError } from "ky";

import { logOut } from "@/redux/actions/logout";
import store from "@/redux/store";
import type { UUID } from "@/core/types";

export const DENY_LIST_EXCEPTION_TYPE = "DenyListException";

const dispatch = store.dispatch;

// Shape of the backend's error envelope (core.response.Response.__struct in
// aptihealth-backend) — code/message always present, type/request_id conditional
// on exception metadata/Lambda context being available. Index signature kept as
// an escape hatch for exception-specific fields the backend may add per type.
export type ServerErrorPayload = {
  [key: string]: unknown;
  code?: number;
  message?: string;
  request_id?: UUID;
  type?: string;
};

export const errorShapeHook: BeforeErrorHook = ({ error: httpError }) => {
  if (!isHTTPError(httpError)) return httpError;

  // Unwrap the backend's "error" envelope key from ky's pre-parsed body
  // (httpError.data) into a flat payload — the single normalization point so
  // callers never need to know the backend's nested response shape.
  const errorPayload = ((httpError.data as { error?: ServerErrorPayload } | null)?.error ??
    {}) as ServerErrorPayload;
  const { type } = errorPayload;

  // Attach errorPayload to the HTTPError instance — consumed by errorToastHook and callers
  Object.assign(httpError, { errorPayload });

  if (type === DENY_LIST_EXCEPTION_TYPE) {
    dispatch(logOut());
  }

  return httpError;
};
